/**
 * Barra de herramientas del documento: flota sobre el contenido, dentro de la
 * vista misma.
 *
 * Leer, escribir y marcar son cosas del documento, no del vault: sus controles
 * tienen que estar sobre el texto y no del otro lado de la pantalla, en el rail
 * que sirve para navegar archivos.
 *
 * Mismo cuerpo que la barra del canvas: UN panel de dos filas. Abajo los
 * controles, que nunca se mueven; arriba, y sólo cuando hacen falta, las
 * opciones de lo que está en la mano. Antes los colores del marcador salían en
 * un panel flotante aparte, encima del texto; siendo una fila del mismo panel
 * no tapan nada y no hay que cerrarlos para seguir leyendo.
 *
 * Componente tonto: pone la barra y tres zonas (opciones, inicio y fin). Quién
 * las llena —y qué hace cada control— es cosa de la vista.
 */
export class DocToolbar {
  readonly root: HTMLElement;
  private toolsEl: HTMLElement;
  private startEl: HTMLElement;
  private endEl: HTMLElement;
  private sepEl: HTMLElement;
  /** Lo último que puso `setOptions`, para poder sacarlo al reemplazarlo. */
  private optionNodes: Node[] = [];

  constructor() {
    this.root = document.createElement("div");
    this.root.className = "doc-toolbar";

    this.startEl = document.createElement("div");
    this.startEl.className = "doc-toolbar-group";
    this.endEl = document.createElement("div");
    this.endEl.className = "doc-toolbar-group";

    this.sepEl = document.createElement("div");
    this.sepEl.className = "toolbar-sep";

    this.toolsEl = document.createElement("div");
    this.toolsEl.className = "toolbar-row";
    this.toolsEl.append(this.startEl, this.sepEl, this.endEl);

    this.root.append(this.toolsEl);
  }

  /**
   * Fila de opciones (arriba). Se muestra u oculta sola: quien la pone es dueño
   * de su `hidden`, así la barra no necesita saber qué hay adentro.
   */
  setOptions(...nodes: Node[]): void {
    for (const n of this.optionNodes) (n as ChildNode).remove?.();
    this.optionNodes = nodes;
    this.root.prepend(...nodes);
  }

  /** Controles alineados a la izquierda (modo de lectura/edición). */
  setStart(...nodes: Node[]): void {
    this.startEl.replaceChildren(...nodes);
  }

  /** Controles alineados a la derecha (marcador). */
  setEnd(...nodes: Node[]): void {
    this.endEl.replaceChildren(...nodes);
  }
}
